import * as React from 'react';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { EgdsHeadingTagStyle } from '../../../../../../constants';
import { ActivityFeature } from '../components/activity-feature';
export var ActivitySpannedTileCardTitle = function (_a) {
  var activity = _a.activity,
    isInCarousel = _a.isInCarousel,
    isVerticalLayout = _a.isVerticalLayout,
    titleLines = _a.titleLines;
  var truncateClasses = {
    1: 'truncate',
    2: 'truncate-lines-2',
    3: 'truncate-lines-3'
  };
  var truncateClass = titleLines && truncateClasses[titleLines] || 'truncate';
  var enhancedCleaningFeature = activity.features.enhancedCleaningFeature;
  var primary = activity.primary;
  return React.createElement("section", null, enhancedCleaningFeature && React.createElement(UitkSpacing, {
    padding: {
      blockend: 'one'
    }
  }, React.createElement(ActivityFeature, {
    label: enhancedCleaningFeature.text,
    icon: enhancedCleaningFeature.icon,
    className: "uitk-type-200",
    "data-testid": "activity-enhanced-cleaning"
  })), React.createElement(UitkSpacing, {
    margin: {
      blockend: 'two'
    }
  }, React.createElement(UitkHeading, {
    tag: primary.headingType ? EgdsHeadingTagStyle[primary.headingType] : 'h3',
    size: 5,
    className: "custom-wrap-text overflow-wrap uitk-type-heading-500 uitk-type-bold ".concat(truncateClass, " ").concat(isInCarousel ? ' carouselTitleHeight' : ''),
    "aria-hidden": "true",
    "data-testid": "activity-spanned-tile-card--title"
  }, primary.text)), !isVerticalLayout && React.createElement(UitkSpacing, {
    margin: {
      blockend: 'two'
    }
  }, React.createElement(UitkText, {
    size: 200,
    className: "grid-section-truncate truncate-lines-2",
    "data-testid": "activity-spanned-tile-card--description"
  }, activity.description)));
};